angular.
module("digiexam").
run(function moduleRunner(
	$rootScope,
	$cookies,
	$window,

	Broadcaster,
	dxLocalize,
	ExamRepository,
	lightbox,
	dxSession,
	DX_URLS,
	Auth,
	RoleTypeEnum,
	dxLanguageCookieSetter
) {
	"use strict";

	// Check if dxLocalize.browserLanguage exists as a locale-file on our end.
	// Right now, we only have sv and en so I'll just make a very simple check.
	var userLanguage = {sv: "sv", en: "en", fi: "fi"}[dxLocalize.browserLanguage];
	var defaultLang = userLanguage ? {locale: dxLocalize.browserLanguage} : {locale: "en"};

	var lang = $cookies.getObject("language") || defaultLang;
	dxLocalize.setLanguage(lang.locale);
	dxLanguageCookieSetter(lang.locale);

	dxSession.restore();

	// Redirect from app.digiexam.se to app.digiexam.com if the user does not have an active session
	// See: https://jira.digiexam.se/browse/WEB-1708
	if ($window.location.hostname === "app.digiexam.se" && !dxSession.isAuthenticated()) {
		$window.location.href = $window.location.href.replace("app.digiexam.se", "app.digiexam.com");
	}

	lightbox.setup();

	$rootScope.$on("$routeChangeStart", function onRouteChangeStart(event, next) {
		if (!next.$$route) {
			return;
		}

		lightbox.close();

		var menuItem = next.$$route.menuItem || "";
		Broadcaster.broadcast("setActiveMenuItem", menuItem);
	});

	angular.element("body").tooltip({selector: "[rel=tooltip]"});

	// Util bindings
	// TODO(kenneth): Remove these from $rootScope.
	// We want to remove them because then we can remove their module dependencies from the "digiexam" module,
	// which makes it easier to have standalone modules with clear dependencies that makes testing much easier.
	$rootScope.ExamRepository = ExamRepository;
	$rootScope.Urls = DX_URLS;
	$rootScope.logout = Auth.logout;
	$rootScope.RoleTypeEnum = RoleTypeEnum;
	$rootScope.dxLocalize = dxLocalize;
	$rootScope.userIsRole = function userIsRole(roleName) {
		var roleNameUpperCase = roleName;
		if (typeof roleName === "string") {
			roleNameUpperCase = roleNameUpperCase.toUpperCase();
		}
		return dxSession.getRole().roleType === RoleTypeEnum[roleNameUpperCase];
	};

	// Helper function to switch language from the developer console
	var DX = $window.DX = $window.DX || {};
	DX.toggleLanguage = function toggleLanguage() {
		var newLang = dxLocalize.setLanguage({en: "sv", sv: "fi", fi: "en"}[dxLocalize.getLanguage()]);
		dxLanguageCookieSetter(newLang);
		$rootScope.$apply();
		return newLang;
	};
});
